import { render, staticRenderFns } from "./Partner-Promotion-View.vue?vue&type=template&id=117b9500&scoped=true"
import script from "./Partner-Promotion-View.vue?vue&type=script&lang=js"
export * from "./Partner-Promotion-View.vue?vue&type=script&lang=js"
import style0 from "./Partner-Promotion-View.vue?vue&type=style&index=0&id=117b9500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117b9500",
  null
  
)

export default component.exports